import { DOMAttr, HTMLAttr, Prop } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { map, contains, forAll, isEmpty } from "./fable_modules/fable-library-js.4.19.0/List.js";
import { stringHash } from "./fable_modules/fable-library-js.4.19.0/Util.js";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.19.0/Seq.js";

function tag(key, selected, title, label, onToggle) {
    let props;
    const children_2 = [(props = [new Prop(0, [key]), new HTMLAttr(65, ["button is-small is-rounded " + (selected ? "is-link is-info" : "")]), new HTMLAttr(158, [title]), new HTMLAttr(159, ["button"]), new DOMAttr(40, [(_arg) => {
        onToggle();
    }])], react.createElement("button", keyValueList(props, 1), label))];
    return react.createElement("p", {
        className: "control",
    }, ...children_2);
}

export function MultiSelector(all, selected, onToggle, onToggleAll) {
    let children_2;
    const isAllSelected = isEmpty(selected) ? true : (!isEmpty(all) && forAll((b) => contains(b.Id, selected, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), all));
    const children_4 = [react.createElement("label", {
        className: "label",
    }, "Bundesländer"), (children_2 = toList(delay(() => append(singleton(tag("alle", isAllSelected, "", "Alle", onToggleAll)), delay(() => map((b_1) => tag(b_1.Id, (isAllSelected === false) && contains(b_1.Id, selected, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: stringHash,
    }), b_1.Bezeichnung, b_1.Abkuerzung, () => {
        onToggle(b_1.Id);
    }), all))))), react.createElement("div", {
        className: "field has-addons is-wrappable",
    }, ...children_2))];
    return react.createElement("div", {
        className: "field",
    }, ...children_4);
}

//# sourceMappingURL=BundeslandSelector.fs.js.map
